import { Observable, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';

let manifestCache$: Observable<any>;
export function getManifest(http: HttpClient): Observable<any> {
  if (!manifestCache$) {
    manifestCache$ = http.get('manifest.json').pipe(
      shareReplay(1),
    );
  }
  return manifestCache$;
}
